/* eslint-disable */

import { useLocation, useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '../../Components/ui/card'
import { Button } from '../../Components/ui/button'
import { Label } from '../../Components/ui/label'
import { Input } from '../../Components/ui/input'
import { post } from '../../http/restservice'
import env from '../../env/env'
import { ChevronDown, ChevronLeft } from 'lucide-react'
import { useModal } from '../../hooks/use-modal-store'
import { useRecoilValueLoadable } from 'recoil'
import { MFTimeBasedBaskets } from '../../store/MFBasketsStore'
import { toCurrency } from '../../utils/CurrencyUtil'

const InvestMoreOneTime = () => {
  const location = useLocation()

  const navigate = useNavigate()
  const [amount, setAmount] = useState(Number(location?.state?.payload?.orderInvestmentAmount) || 0)
  const [amountInput, setAmountInput] = useState('0')

  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState('')
  const { onOpen } = useModal()

  const baskets = useRecoilValueLoadable(MFTimeBasedBaskets)

  // Initialize formatted input once on mount
  useEffect(() => {
    setAmountInput(toCurrency(Number(amount || 0)))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleAmountInputChange = (e) => {
    const raw = (e?.target?.value || '').toString().replace(/[^0-9]/g, '')
    const numeric = raw ? Number(raw) : 0
    setAmount(numeric)
    setAmountInput(toCurrency(numeric))
  }

  const educationConstituentsOneTimeWeightage = {
    // 'edutrg-gr': 0,
    'edatgp-gr': 20,
    'pp001rg-gr': 25,
    'cmfcgp-gr': 30,
    'relsegp-gr': 25,
  }

  const weddingConstituentsOneTimeWeightage = {
    'edutrg-gr': 0,
    'edmarg-gr': 20,
    'rmfgdgp-gr': 10,
    'pp001rg-gr': 25,
    earg: 20,
    dfg: 25,
  }

  const retirementConstituentsWeightageOneTime = {
    'edutrg-gr': 0,
    dynmic: 15,
    'pp001rg-gr': 15,
    'edatgp-gr': 10,
    'cmfcgp-gr': 30,
    'qumogp-gr': 30,
  }

  const oneToThreeYrConstituentsWeightage = {
    'km35-gr': 50, // Kotak Equity Savings
    'pp001rg-gr': 50, // Parag Parikh Flexi Cap Fund
  }

  const oneYrConstituentsWeightage = {
    'edmarg-gr': 50,
    'relmtf-gr': 50,
  }

  const emergencyConstituentsOneTimeWeightage = { 'edatgp-gr': 100 }

  const commoditiesConstituentsOneTimeWeightage = {
    'edgfrg-gr': 100,
  }

  const anytimeConstituentsWeightage = {
    'rmfgdgp-gr': 30, // Nippon Gold Fund
    'km35-gr': 70, // Kotak Equity Savings
  }

  const threeToSixWithoutUsTechOT = {
    'edatgp-gr': 20, // Edelweiss Multi Asset Allocation Fund-Reg(G)
    'pp001rg-gr': 25, // Parag Parikh Flexi Cap Fund-Reg(G)
    'cmfcgp-gr': 30,
    'relsegp-gr': 25, // Nippon India Large Cap Fund
  }

  const sixPlusWithoutUsTechOT = {
    'edatgp-gr': 10, // Edelweiss Multi Asset Allocation Fund-Reg(G)
    'cmfcgp-gr': 30,
    'qumogp-gr': 30, // Quant Momentum Fund
    dynmic: 15, // ICICI Pru multi asset
    'pp001rg-gr': 15, // Parag Parikh Flexi Cap Fund-Reg(G)
  }

  const arbitrageOT = {
    'edatgp-gr': 100,
  }

  const liquidOT = {
    'rellftpi-gr': 100,
  }

  const cm = {
    'cmfcgp-gr': 100,
  }
  //16
  const oneTaxEfficient = {
    'edatgp-gr': 50,
    'rmfaf-gr': 50,
  }

  const usTech = {
    'icici1950-gr': 100,
  }

  const chinaEquity = {
    'edgcgp-gr': 100,
  }

  const sifQuant = {
    'quslsgp-gr': 100,
  }

  const sipAggressive4K = {
    'cmfcgp-gr': 25,
    'pp001rg-gr': 25,
    'qumogp-gr': 25,
    'dynmic': 25,
  }

  const basketOptions = {
    1: '6+ Retirement',
    2: '3-6 Education',
    3: '3-6 Wedding',
    4: '1-3',
    5: '1',
    6: 'Emergency',
    8: 'Commodities',
    10: 'Anytime',
    11: '6+_Retirement_Without_US_Tech',
    12: '3-6_Education_Without_US_Tech',
    13: 'Arbitrage',
    14: 'Liquid',
    15: 'CM',
    16: '1_Tax_Efficient',
    17: 'US_Tech',
    18: 'China_Equity',
    19: 'SIF_6+_Retirement',
    20: 'SIP_Aggressive_4K'
  }

  const basketMin = {
    1: 33500,
    2: 20000,
    3: 4000,
    5: 200,
    4: 2000,
    6: 100,
    8: 100,
    10: 350,
    11: 33500,
    12: 20000,
    13: 100,
    14: 1000,
    15: 5000,
    16: 10000,
    17: 100,
    18: 100,
    19: 10000,
    20: 0,
  }

  const universalBasketId =
    +location?.state?.basket[0]?.universalBasketId || +location?.state?.basket?.universalBasketId

  const basketMinAmount = basketMin[universalBasketId]
  const basketName = basketOptions[universalBasketId]?.toLowerCase()

  const filteredConstituents =
    baskets?.state === 'hasValue'
      ? (() => {
        const relevantFunds = baskets?.contents?.data?.filter(
          (fund) => fund?.universalBasketId === universalBasketId,
        )

        if (amount < basketMinAmount) {
          const fallbackFund = relevantFunds?.find(
            (fund) => fund?.bseSchemeCode?.toLowerCase() === 'cmfcgp-gr',
          )

          return fallbackFund
            ? [
              {
                ...fallbackFund,
                weightage: 100,
              },
            ]
            : []
        }

        return relevantFunds
          ?.map((fund) => {
            const schemeCode = fund?.bseSchemeCode?.toLowerCase()

            const weightage =
              basketName == '6+ retirement'
                ? retirementConstituentsWeightageOneTime[schemeCode]
                : basketName.includes('sif_6+_retirement')
                  ? sifQuant[`${fund.bseSchemeCode.toLowerCase()}`]
                  : basketName.includes('1_tax_efficient')
                    ? oneTaxEfficient[`${fund.bseSchemeCode.toLowerCase()}`]
                    : basketName == '6+_retirement_without_us_tech'
                      ? sixPlusWithoutUsTechOT[schemeCode]
                      : basketName.includes('cm')
                        ? cm[`${fund.bseSchemeCode.toLowerCase()}`]
                        : basketName.includes('3-6_education_without_us_tech')
                          ? threeToSixWithoutUsTechOT[schemeCode]
                          : basketName.includes('3-6 education')
                            ? educationConstituentsOneTimeWeightage[schemeCode]
                            : basketName.includes('wedding')
                              ? weddingConstituentsOneTimeWeightage[schemeCode]
                              : basketName.includes('emergency')
                                ? emergencyConstituentsOneTimeWeightage[schemeCode]
                                : basketName.includes('commodities')
                                  ? commoditiesConstituentsOneTimeWeightage[schemeCode]
                                  : basketName.includes('liquid')
                                    ? liquidOT[schemeCode]
                                    : basketName.includes('arbitrage')
                                      ? arbitrageOT[schemeCode]
                                      : basketName.includes('1-3')
                                        ? oneToThreeYrConstituentsWeightage[schemeCode]
                                        : basketName.includes('1')
                                          ? oneYrConstituentsWeightage[schemeCode]
                                          : basketName.includes('us_tech')
                                            ? usTech[`${fund.bseSchemeCode.toLowerCase()}`]
                                            : basketName.includes('china_equity')
                                              ? chinaEquity[`${fund.bseSchemeCode.toLowerCase()}`]
                                              : anytimeConstituentsWeightage[schemeCode]

            return weightage
              ? {
                ...fund,
                weightage,
              }
              : null
          })
          ?.filter(Boolean) // removes null entries
      })()
      : []

  // console.log(filteredConstituents)

  const minimumInvestmentAmount = filteredConstituents
    ? filteredConstituents.reduce((acc, fund) => acc + (Number(fund.minOneTime) || 0), 0)
    : 0

  const handleSubmit = async () => {
    setError('')

    // Basic validation
    if (!amount || isNaN(Number(amount)) || Number(amount) <= 0) {
      setError('Please enter a valid investment amount')
      return
    }

    if (
      location?.state?.payload?.orderInvestmentAmount &&
      location?.state?.payload?.orderInvestmentBreakdown
    ) {
      const url = `${env.API_URL}adminservice/api/actionPlan/subsequentOneTimeOrder`

      const newData = filteredConstituents?.map((item) => {
        const investmentAmount = parseFloat((amount / 100) * item.weightage)

        return {
          ...item,
          investmentAmount,
          customerBasketInvestmentId: location?.state?.basket[0]?.customerBasketInvestmentId,
          customerBasketName: location?.state?.basket[0]?.customerBasketName,
        }
      })

      const payload = {
        clientCode: location?.state?.payload?.clientCode,
        orderInvestmentAmount: amount,
        orderInvestmentBreakdown: newData?.filter((fund) => fund?.weightage > 0),
        customerBasketInvestmentId: location?.state?.basket?.customerBasketInvestmentId,
      }


      setIsLoading(true)

      const response = await post(url, payload)

      setIsLoading(false)

      if (
        response?.status === 'SUCCESS' &&
        response?.message?.includes('Order created successfully')
      ) {
        onOpen('openAdminPopup', {
          title: 'Order Created!',
          message: 'Your order has been successfully created.',
          severity: 'success',
        })
      } else {
        onOpen('openAdminPopup', {
          title: 'Order Failed!',
          message:
            'There was an issue creating your order. Please try again later or contact support if the issue persists.',
          severity: 'error',
        })
      }

      return
    }

    const newData = filteredConstituents?.map((item) => {
      const investmentAmount = parseFloat((amount / 100) * item.weightage)

      return {
        ...item,
        investmentAmount,
        customerBasketInvestmentId: location?.state?.basket[0]?.customerBasketInvestmentId,
        customerBasketName: location?.state?.basket[0]?.customerBasketName,
      }
    })

    const url = `${env.API_URL}adminservice/api/actionPlan/subsequentOneTimeOrder`

    const payload = {
      clientCode: location?.state?.clientCode,
      orderInvestmentAmount: amount,
      orderInvestmentBreakdown: newData?.filter((fund) => fund?.weightage > 0),
      customerBasketInvestmentId: location?.state?.basket[0]?.customerBasketInvestmentId,
    }

    setIsLoading(true)

    const response = await post(url, payload)

    setIsLoading(false)

    if (
      response?.status === 'SUCCESS' &&
      response?.message?.includes('Order created successfully')
    ) {
      onOpen('openAdminPopup', {
        title: 'Order Created!',
        message: 'Your order has been successfully created.',
        severity: 'success',
      })
    } else {
      onOpen('openAdminPopup', {
        title: 'Order Failed!',
        message:
          'There was an issue creating your order. Please try again later or contact support if the issue persists.',
        severity: 'error',
      })
    }
  }

  return (
    <>
      <ChevronLeft onClick={() => navigate(-1)} className='cursor-pointer' />
      <div className='container flex items-center justify-center min-h-[70vh] py-12'>
        <Card className='w-full max-w-xl'>
          <CardHeader>
            <CardTitle className='text-2xl font-bold'>
              {location?.state?.basket[0]?.customerBasketName ||
                location?.state?.basket?.customerBasketName}{' '}
              - (One-Time)
            </CardTitle>
            <CardDescription>
              Enter the amount you would like to invest in your portfolio
            </CardDescription>
          </CardHeader>

          <CardContent>
            <div className='space-y-4'>
              <div className='space-y-2'>
                <Label htmlFor='amount' className='font-semibold'>
                  One-Time Investment Amount
                </Label>
                <div className='relative'>
                  <Input
                    startAdornment='₹'
                    id='amount'
                    type='text'
                    placeholder='0'
                    className='pl-10'
                    value={amountInput}
                    onChange={handleAmountInputChange}
                  />
                </div>
                {error && <p className='text-sm font-medium text-red-500'>{error}</p>}
              </div>

              <div className='flex justify-center items-center'>
                <Button
                  variant='link'
                  size='simple'
                  className='text-primary-500 p-0 border-b border-dashed border-primary-500 rounded-none hover:no-underline'
                  onClick={(e) => {
                    e.stopPropagation(),
                      onOpen('OpenAdminMFBreakdown', {
                        constituents: filteredConstituents?.filter((item) => item.weightage > 0),
                        amount: amount,
                      })
                  }}
                >
                  View detailed breakdown
                  <ChevronDown className='h-4 w-4 ml-1' />
                </Button>
              </div>

              {/* {amount < minimumInvestmentAmount && (
                <div>
                  <p className='text-sm text-error-500 text-center'>
                    Minimum investment amount is {toCurrency(minimumInvestmentAmount)}
                  </p>
                </div>
              )} */}
            </div>
          </CardContent>

          <CardFooter>
            <Button
              onClick={handleSubmit}
              type='submit'
              className='w-full bg-primary-500 disabled:bg-primary-300'
              disabled={isLoading || amount == 0}
            >
              {isLoading ? 'Processing...' : 'Continue'}
            </Button>
          </CardFooter>
        </Card>
      </div>
    </>
  )
}

export default InvestMoreOneTime
